<template>
    <b-card>
        <h4>تکمیل حساب کاربری</h4>
        <div class="pt-2">
            <div @click.prevent="$router.push('identity-management')">
                <b-form-checkbox v-model="statusCompletionData.isAdminIdentityVerified" class="custom-control-primary">
                    <h5 class="mb-2"> تایید هویت مدیر</h5>
                </b-form-checkbox>
            </div>

            <div @click.prevent="$router.push('categories')">
                <b-form-checkbox v-model="statusCompletionData.hasAnyCategory" class="custom-control-primary">
                    <h5 class="mb-2">ایجاد حداقل یک دسته</h5>
                </b-form-checkbox>
            </div>

            <div @click.prevent="$router.push('products')">
                <b-form-checkbox v-model="statusCompletionData.hasAnyProduct" class="custom-control-primary">
                    <h5>ایجاد حداقل یک محصول</h5>
                </b-form-checkbox>
            </div>
        </div>
    </b-card>
</template>
  
<script>
import { BRow, BCol, BCard, BCardText, BCardBody, BButton, BFormCheckbox } from 'bootstrap-vue';
export default {
    name: 'undoneTasks',
    components: {
        BRow,
        BCol,
        BCard,
        BCardText,
        BCardBody,
        BButton,
        BFormCheckbox
    },
    props: {
        statusCompletionData: {
            type: Object,
            default: () => { },
        },
    },
}
</script>